var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"basket_button",on:{"click":_vm.redirectToShoppingCart}},[_c('img',{staticClass:"cart_img",attrs:{"src":require("../img/cart.png"),"alt":"cart"}}),(_vm.itemsInBasket > 0)?_c('span',{staticClass:"_badge roboto_9_normal"},[_vm._v(" "+_vm._s(_vm.itemsInBasket)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }